import { apiClient } from "../api"
import { DTO_Area, DTO_AreaMonitoring, DTO_FleetArea } from "./types/area"

enum Area {
  FLEET_AREA = '/fleetarea/',
  AREA_MON = '/areamon/'
}

export const getAreaMonitoring = (): Promise<DTO_AreaMonitoring[]> => {
  const ac = apiClient()
  const promise = ac.get(Area.FLEET_AREA)
    .then(res => res.data)
  return promise
}

export const createArea = (data: DTO_Area) : Promise<DTO_AreaMonitoring> => {
  const ac = apiClient()
  const promise = ac.post(Area.FLEET_AREA, {
    ...data
  }).then(res => res.data)
  return promise
}

export const updateArea = (data: DTO_Area, id: number) : Promise<DTO_AreaMonitoring> => {
  const ac = apiClient()
  const promise = ac.patch(`${Area.FLEET_AREA}${id}/`, {
    ...data
  }).then(res => res.data)
  return promise
}

export const deleteArea = (id: number) : Promise<void> => {
  const ac = apiClient()
  const promise = ac.patch(`${Area.FLEET_AREA}${id}/`, {
    enabled: false
  }).then(res => res.data)
  return promise
}

export const getFleetArea = (): Promise<DTO_FleetArea[]> => {
  const ac = apiClient()
  const promise = ac.get(Area.AREA_MON)
    .then(res => res.data)
  return promise
}

export const createFleetArea = (data: DTO_FleetArea) : Promise<DTO_AreaMonitoring> => {
  const ac = apiClient()
  const promise = ac.post(Area.AREA_MON, {
    ...data
  }).then(res => res.data)
  return promise
}
